import {NICEStudioScriptData} from './NICE_ScriptData.model';

export class NICEStudioScript
{
    scriptId: number;
    scriptName: string;
    scriptPath: string;
    createDate: string;
    lastModified: string;
    lastModUser: string;
    lastExecuted: string
    hidden: boolean;
    readOnly: boolean;
    isLocked: boolean;
    lockedBy: string;
    mediaTypeId: number;
    mediaTypeName: string;
    isActive: boolean;
    filePath: string;
    name: string;
    scriptStatus: string;
    body: string;
    isSupressionScript = false;
    scriptData: NICEStudioScriptData;
    parameters: string[];



    constructor(niceScript?)
    {
        if (niceScript != null) {
            this.lastExecuted = niceScript.lastExecuted;
            this.isActive = niceScript.isActive === 'True';
            this.hidden = niceScript.hidden === 'True';
            this.readOnly = niceScript.readOnly === 'True';
            this.isLocked = niceScript.isLocked === 'True';
            this.lockedBy = niceScript.lockedBy;
            this.mediaTypeName = niceScript.mediaTypeName;
            this.mediaTypeId = +niceScript.mediaTypeId;
            this.createDate = niceScript.createDate;
            this.lastModified = niceScript.lastModified;
            this.body = niceScript.body;
            if (this.body!=='')
            {
                this.scriptData = new NICEStudioScriptData(this.body);
            }
            this.scriptId = +niceScript.scriptId || +niceScript.ScriptId;
            if (niceScript.filePath)  // only populated on get single script.
            {
                this.name = niceScript.name;
                this.filePath = niceScript.filePath;
                this.scriptPath = this.filePath;
                this.filePath = this.filePath.substr(0, this.filePath.length - this.name.length);
                this.scriptName = niceScript.name;
            }
            else
                {
                    this.scriptName = niceScript.scriptName;
                    if (this.scriptName.indexOf('\\') > -1)
                    {
                        this.filePath = this.scriptName.substr(0, this.scriptName.lastIndexOf('\\'));
                        this.name = this.scriptName.substr(this.scriptName.lastIndexOf('\\') + 1);
                        this.scriptPath = this.filePath + '\\' + this.name;
                    }
                    else
                    {
                        this.name = this.scriptName;
                        this.filePath = '';
                        this.scriptPath = this.name;
                    }
                    this.lastModUser = niceScript.mUser;
                    this.scriptId = +niceScript.masterID;
                    this.lastModified = niceScript.modifyDate;
                    this.scriptStatus = niceScript.status;
                    this.mediaTypeId = +niceScript.mediaType;
                    if (niceScript.actions) {
                        this.isSupressionScript = (niceScript.actions.find(element => element.name === 'PERMITCALL' || element.name === 'SUPPRESSCALL') != null);
                    }
                    switch (this.mediaTypeId) {
                        case 0: {
                            this.mediaTypeName = 'Code';
                            break;
                        }
                        case 1: {
                            this.mediaTypeName = 'E-Mail';
                            break;
                        }
                        case 2: {
                            this.mediaTypeName = 'Fax';
                            break;
                        }
                        case 3: {
                            this.mediaTypeName = 'Chat';
                            break;
                        }
                        case 4: {
                            if (this.isSupressionScript)
                            {
                                this.mediaTypeName = 'Suppression Script';
                                break;
                            }
                            this.mediaTypeName = 'Phone Call';
                            break;
                        }
                        case 5: {
                            this.mediaTypeName = 'Voice Mail';
                            break;
                        }
                        case 6: {
                            this.mediaTypeName = 'Work Item';
                            break;
                        }
                        case 7: {
                            this.mediaTypeName = 'SMS';
                            break;
                        }
                        case 8: {
                            this.mediaTypeName = 'Social';
                            break;
                        }
                        case 9: {
                            this.mediaTypeName = 'Digital';
                            break;
                        }
                        default: {
                            this.mediaTypeName = 'Unknown';
                        }
                    }
                }
        }
    }

}


